import baseAssignValue from './_baseAssignValue.js';
import eq from './eq.js';

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

export default assignMergeValue;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_assignMergeValue.js
// module id = 273
// module chunks = 23